export const ADMIN_SIDEBAR = [
  { label: 'Dashboard', icon: 'dashboard', path: '/admin/dashboard' },
  { label: 'Bookings', icon: 'gigs', path: '/admin/bookings' },
  { label: 'Financials', icon: 'financials', path: '/admin/financials' },
  { label: 'Users', icon: 'providers', path: '/admin/users' },
  { label: 'Verifications', icon: 'verifications', path: '/admin/verifications' },
  { label: 'Services', icon: 'services', path: '/admin/services' },
  { label: 'Messages', icon: 'messages', path: '/admin/messages' },
  { label: 'Inquiries', icon: 'inquiries', path: '/admin/inquiries' },
];

export const PROVIDER_SIDEBAR = [
  { label: 'Dashboard', icon: 'dashboard', path: '/provider/dashboard' },
  { label: 'Messages', icon: 'messages', path: '/provider/messages' },
  { label: 'Settings', icon: 'settings', path: '/provider/settings' },
  { label: 'Bookings', icon: 'gigs', path: '/provider/bookings' },
];

export const CLIENT_SIDEBAR = [
  { label: 'Dashboard', icon: 'dashboard', path: '/client/dashboard' },
  { label: 'My Bookings', icon: 'gigs', path: '/client/bookings' },
  { label: 'Track Booking', icon: 'requests', path: '/client/track' },
  { label: 'Invoices', icon: 'invoices', path: '/client/invoices' },
  { label: 'Book a Service', icon: 'services', path: '/book' },
];
